<template>
    <div class="contact">
        <h1>联系我们</h1>
        
        <!-- <div class="section" v-for="(content, index) in sections" :key="index">
            <h2>{{ content.title }}</h2>
            <p v-if="content.body" style="text-align: left;"> &emsp; &emsp; {{ content.body }}</p>
        </div> -->
        
        <!-- Optional: Include images or illustrations related to the laboratory -->
        
        <div class="section" v-if="hasImages">
            <h2>微信公众号与小红书</h2>
            <div class="flex-container">
                <div class="flex-item" v-for="(image, index) in images" :key="index">
                    <img v-loading="{ minHeight: '50px', minWidth: '50px', size: '25px' }" :src="require('../assets/images/Contact/' + image.src)" :alt="image.title">
                </div>
            </div>
            <h2>邮箱：<a href="mailto:contact@s7edu.com">contact@s7edu.com</a></h2>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        sections: [
        ],
        // Images array can be added here if available
        images: [
            { src: "0.png", title: '微信公众号二维码' },
            { src: "1.png", title: '小红书二维码' },
        ],
        hasImages: true, // Set to true if images array is defined
        };
    },
};
</script>

<style scoped>
/* Add basic styling for readability */
.contact {
    padding: 3vw;
    font-family: 'FangYuan';
    color: #513890;
    /* font-size: calc(100vw * 20 / 1920); */
    font-weight: normal;
    /* letter-spacing: 0.16em; */
    line-height: 2em;
}

body {
    line-height: 1.6;
    margin: 0;
    padding: 0;
}

h1 {
    text-align: center;
    margin-top: 1vmin;
    font-size: 5vmin;
}

.section {
    text-align: center;
}

h2 {
    margin: 0rem;
    font-size: 3vmin;
}

ul {
    display: flex;
    list-style-type: disc;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
}

ul li {
    display: inline;
    flex: 1;
    text-align: left;
}

p {
    margin-bottom: 1rem;
}

.highlight {
    font-weight: bold;
}

.flex-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.flex-item {
    margin: 0.25rem 0.5rem;
}

img {
    width: 20vmax;
    height: auto;
}
</style>